import i18n from "i18next";
import { LANGUAGES, languageLabel } from "@/lib/mobileSettings";
import styles from "../DocumentStamp.module.scss";

export interface LanguageSectionProps {
  /** The document's setting: a code, or "auto". */
  value: string | undefined;
  /** With "auto": what the text reads as. */
  detected?: string | null;
  onChange: (language: string) => void;
  disabled?: boolean;
}

/**
 * The document's language (19 Oct, API #350): the PDF's headings (Contents, Figure, References),
 * its word breaks, and for Arabic and Hebrew its direction. Separate from the interface's language.
 * Languages are named in their own language; "Automatic" reads it from the text.
 */
export function Language({ value, detected, onChange, disabled }: LanguageSectionProps) {
  const current = value || "auto";
  const auto = i18n.t("editor:stamp.languageAuto");
  return (
    <div className={styles.section} data-testid="document-stamp-language">
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>{i18n.t("editor:stamp.language")}</span>
        {disabled && <span className={styles.readOnlyPip}>{i18n.t("editor:stamp.readOnly")}</span>}
      </div>
      <select
        data-testid="document-stamp-language-select"
        aria-label={i18n.t("editor:stamp.language")}
        value={current}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className={styles.languageSelect}
      >
        {LANGUAGES.map((l) => (
          <option key={l.value} value={l.value}>
            {languageLabel(l.value, auto, l.value === "auto" ? detected : null)}
          </option>
        ))}
      </select>
      <p className={styles.languageHint}>{i18n.t("editor:stamp.languageHint")}</p>
    </div>
  );
}
